import React, { useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

import { InputText } from 'primereact/inputtext';

import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

import Conexao from "../../../providers/Conexao";
import DeleteButton from '../../../Componentes/DeleteButton';
import { Skeleton } from 'primereact/skeleton';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import UpdateButton from "../../../Componentes/UpdateButton";
import { FilterMatchMode } from 'primereact/api';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import SidebarDCA from "../Clientes/SidebarDCA";


export default function DialogDcas(props) {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [edicao, setEdicao]= useState(false);
    const [dca, setDca] = useState([])
    const [dcas, setDcas] = useState([])
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
            hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
        });
    const [fieldsFound, setFieldsFound] = useState([]);

    useEffect(()=>{
        
        if(props.licenca.visible){
            getDca()
        }

    }, [props.licenca.visible])

    const getDca = async () => {
            if(props.setLoading){
                props.setLoading(true)
            }
            try {
                const response = await Conexao.post('dcaController/getDca',{
                    idusuario : props.dataEmpresa.idrevenda, 
                    idempresa : props.dataEmpresa.idempresa, 
                    idcliente : props.idcliente
                }                );
                setDcas(response.status === 200 && response.data.status === 'OK' ? response.data.payload : []);
                if(props.setLoading){
                    props.setLoading(false)
                }
            } catch {
                setDcas([]);
                if(props.setLoading){
                    props.setLoading(false)
                }
            }
        };

     const renderHeader = () => {
                    return (
                        <div className="flex justify-content-between align-items-center" style={{paddingBottom : '10px', paddingTop : '10px', paddingLeft : '0px'}}>
                           
                            <div className="flex align-items-center gap-2">
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search" />
                                    <InputText 
                                        value={globalFilterValue} 
                                        onChange={onGlobalFilterChange} 
                                        placeholder="Pesquisa global" 
                                        tooltip="Pesquise por qualquer campo da tabela" tooltipOptions={{ position: 'bottom' }}
                                    />
                                </IconField>
                                <Button 
                                    icon="pi pi-filter-slash" 
                                    className="p-button-secondary p-button-sm" 
                                    onClick={clearFilters} 
                                    tooltip="Limpar todos os filtros" tooltipOptions={{ position: 'bottom' }}
                                />
                                
                                <Button 
                                    icon="pi pi-plus" 
                                    className= "p-button-primary p-button-sm" 
                                    disabled ={props.fixarCliente}
                                    tooltip="Nova Licença" tooltipOptions={{ position: 'bottom' }}
                                    onClick={()=>{
                                        if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                        
                                            props.showMessage("warn", 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                            return;
                                        } 
                                        confirmDialog({
                                            message: 'Confirma a Criação de uma Chave DCA para o cliente?',
                                            header: 'Confirmação',
                                            icon: 'pi pi-exclamation-triangle',
                                            acceptLabel: 'Sim',
                                            rejectLabel: 'Não',
                                            accept: () => {
                                            props.setLoading(true)
                                            Conexao.post('dcaController/insertDcaV2', {
                                                chave : props.licenca.chaveDCA, 
                                                explode : 'T', 
                                                idcliente : props.licenca.idcliente, 
                                                idempresa :props.licenca.idempresa , 
                                                idusuario :props.licenca.idusuario, 
                                                razaosocial : props.licenca.razaosocial, 
                                                serviceInventory : false
                                                }).then(response=>{
    
                                                    if(response.status == 200 && response.data.status == 'OK'){
    
                                                        setDcas(prevData => [...prevData, response.data.payload]); 
    
                                                        props.showMessage('success', 'Cadastro de Licenças', 'Registro inserido com sucesso!') 
    
                                                    }else{
    
                                                        props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível inserir registro')  
    
                                                    }
    
                                                    props.setLoading(false)     
                                                                                 
                                                }).catch(error=>{
    
                                                    props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível inserir registro')  
    
                                                    props.setLoading(false)   
    
                                                })
    
                                                
                                            }
                                            });   
                                    }}
                                />            
                            </div>
                            
                        </div>
                    );
                };

    const onGlobalFilterChange = (e) => {
    
            const value = e.target.value;

            setGlobalFilterValue(value);
        
            setFilters(prevFilters => ({
                ...prevFilters,
                global: { value, matchMode: FilterMatchMode.CONTAINS }
            }));

        };
    const clearFilters = () => {
            setGlobalFilterValue('');
            setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            chavecoletor: { value: '', matchMode: FilterMatchMode.CONTAINS },
            hostname: { value: '', matchMode: FilterMatchMode.EQUALS },
            datacadastro: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataativacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dataatualizacao: { value: '', matchMode: FilterMatchMode.EQUALS },
            dcaversao: { value: '', matchMode: FilterMatchMode.EQUALS }
            });
            setFieldsFound([]); // Resetando os campos encontrados
        };

    return <div >
              
               
                <Dialog
                    header="Chaves de Coleta (DCAs)"
                    visible={props.licenca.visible}
                    maximizable
                    blockScroll={false} 
                    style={{ width: '60vw', }} // Largura padrão
                    breakpoints={{ '960px': '75vw', '720px': '90vw' }} // Ajuste para telas menores
                    onHide={() => props.setLicenca()}
                >

                 <DataTable
                        value={dcas}
                        header={renderHeader()}
                        paginator                 
                        rows={15} // Número de itens por página
                        rowsPerPageOptions={[10, 15, 20, 25]} // Opções de páginas
                        responsiveLayout="scroll"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                        tableStyle={{ minWidth: '35rem', fontSize : '10px' }}
                        filters={filters}
                        globalFilterFields={['chave', 'datacadastro', 'dataativacao', 'dataatualizacao', 'hostname', 'dcaversao']}
                        bodyStyle={{fontSize : '10px'}}                            
                        rowClassName={rowData => rowData.ativo === 'f' ? 'row-inativo' : ''}
                    >
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="chave" 
                            header="Chave DCA" 
                            name="chave" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                                />
    
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="datacadastro" 
                            header="Criação" 
                            name="datacadastro" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                            />
    
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="dataativacao" 
                            header="Instalação" 
                            name="dataativacao" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                            />
    
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="dataatualizacao" 
                            header="Comunicação" 
                            name="dataatualizacao" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                            />
    
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '15%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="hostname" 
                            header="Hostname" 
                            name="hostname" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                            />
    
                        <Column 
                            bodyStyle={{ fontSize: '11px' , width : '8%', paddingTop:'8px', paddingBottom: '8px' }} 
                            headerStyle={{ fontSize:'12px' }} 
                            field="dcaversao" 
                            header="Versão" 
                            name="dcaversao" 
                            body={loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : null}
                            sortable 
                            />
                        <Column 
                                bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px' , textAlign:'center' }} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                header="Editar"
                                body={(row)=> loading ? <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> : 
                                <UpdateButton
                                    disabled = {row.ativo ==='f' || props.fixarCliente}
                                    style={{padding : '2px'}} className='w-full' onClick = {()=>{
                                        if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                        
                                            props.showMessage("warn", 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                            return;
                                        } 
                                    setEdicao(true)
                                    setDca(row)
                                }}/>}                         
                            />
        
                        <Column 
                                bodyStyle={{ fontSize: '11px' , width : '3%', paddingTop:'4px', paddingBottom: '4px', textAlign:'center' }} 
                                headerStyle={{ fontSize:'12px', paddingTop:'8px', paddingBottom: '8px',  }} 
                                header="Excluir"
                                body={(row)=> loading ? 
                                            <Skeleton height="1.5rem" width="99%" style={{ marginBottom: '10px' }} /> 
                                                : 
                                            <DeleteButton severity="danger" style={{padding : '2px'}} className='w-full'
                                            disabled = {row.ativo ==='f' || row.dataativacao || props.fixarCliente}
                                            onClick={()=>{
                                                if(props.dataEmpresa.bloqueiofinanceiro === 't') {
                        
                                                    props.showMessage("warn", 'Este recurso esta Bloqueado! Entre em contato com a Databit');
                                                    return;
                                                    
                                                } 
                                                confirmDialog({
                                                    message: 'Confirma a EXCLUSÂO essa chave de instalação?',
                                                    header: 'Confirmação',
                                                    icon: 'pi pi-exclamation-triangle',
                                                    acceptLabel: 'Sim',
                                                    rejectLabel: 'Não',
                                                    accept: () => {
                                                    if(props.setLoading){
                                                        props.setLoading(true)
                                                    }
                                                   
                                                    props.Conexao.post('dcaController/removeDca', {
                                                        idusuario : row.idusuario, 
                                                        idempresa : row.idempresa, 
                                                        idcliente : row.idcliente, 
                                                        iddca : row.iddca
                                                        }).then(response=>{
    
                                                            if(response.status == 200 && response.data.status == 'OK'){
    
                                                                setDcas(prevData => [...prevData.filter(item => item.iddca !== row.iddca )]); 
    
                                                                props.showMessage('success', 'Cadastro de Licenças', 'Registro removido com sucesso!')  
    
                                                            }else{
    
                                                                props.showMessage('warn', 'Cadastro de Licenças', 'Não foi possível remover registro')  
    
                                                            }
    
                                                            props.setLoading(false)      
    
                                                        }).catch(error=>{
    
                                                            props.showMessage('error', 'Cadastro de Licenças', 'Não foi possível remover registro')  
    
                                                            props.setLoading(false)      
                                                                                        
                                                        })
            
                                                        
                                                    }
                                                    }); 
                                            }}/>}                         
                            />
    
                    </DataTable> 
                </Dialog>
            <SidebarDCA 
                getDca ={props.getDca} 
                showMessageToast ={props.showMessage} 
                dca = {dca} setDca = {setDca} locaisInstalacao = {props.locaisInstalacao} 
                showMessage ={props.showMessage}
                getLocaisByCliente ={props.getLocaisByCliente}/>
            </div>

                }